module.exports = __webpack_public_path__ + "static/media/team-icon.ff407a4b.svg";